export default "__VITE_ASSET__BB1L8gSp__"